import $bdjGp$bleckertevents from "@bleckert/events";


class $747425b437e121da$export$f391db14ff2d9279 extends (0, $bdjGp$bleckertevents) {
    constructor(states, initial = "IDLE", data = {}, actions = {}){
        super();
        this.states = states;
        this.initial = initial;
        this.state = initial;
        this.actions = actions;
        this._defaultData = {
            ...data
        };
        this.set(this._defaultData);
    }
    can(action) {
        return action in this.states[this.state].on;
    }
    isFinal() {
        return this.states[this.state].final;
    }
    transition(prevState, input) {
        if (prevState) this.emit(`${prevState}-OFF`);
        this.emit(this.state, input);
        this.emit("transition", this.state, prevState, input);
        if (this.actions[this.state]) this.actions[this.state](this, input);
    }
    dispatch(actionName, input = null) {
        if (!this.can(actionName)) return;
        const currentState = this.state;
        this.state = this.states[this.state].on[actionName];
        this.transition(currentState, input);
    }
    start(input = null) {
        this.transition(null, input);
    }
    reset(input = null) {
        this.set({
            ...this._defaultData
        });
        this.state = this.initial;
        this.start(input);
    }
    offState(state, cb) {
        this.on(`${state}-OFF`, cb);
    }
    set(data) {
        this.data = data;
        Object.freeze(this.data);
    }
    setData(data) {
        this.set({
            ...this.data,
            ...data
        });
        this.emit("data", data);
    }
}
const $747425b437e121da$var$store = {};
function $747425b437e121da$export$aaa7fa18f8e9b2e8(config) {
    if (!$747425b437e121da$var$store[config.id]) $747425b437e121da$var$store[config.id] = new $747425b437e121da$export$f391db14ff2d9279(config.states, config.initial, config.data, config.actions);
    return $747425b437e121da$var$store[config.id];
}


export {$747425b437e121da$export$f391db14ff2d9279 as Machine, $747425b437e121da$export$aaa7fa18f8e9b2e8 as createMachine};
//# sourceMappingURL=module.js.map
